import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as accountStore from "@containers/Account/store";
import { actions as PayPerLeadActions, selectors as PayPerLeadSelectors } from "@containers/PayPerLead/store";

import { GetSubscriptionStatisticsRequest } from "../interface";

export type FetchSubscriptionStatisticsProps = Omit<GetSubscriptionStatisticsRequest, "account_id">;

export const useFetchSubscriptionStatistics = () => {
  const dispatch = useDispatch();

  const activeAccount = useSelector(accountStore.selectors.getActiveAccount());

  return useCallback(
    (args: FetchSubscriptionStatisticsProps) => {
      if (activeAccount?.id) {
        dispatch(
          PayPerLeadActions.getSubscriptionStatistics.request({
            ...args,
            account_id: activeAccount.id,
          }),
        );
      }
    },
    [activeAccount?.id, dispatch],
  );
};

export const useSubscriptionStatistics = () => {
  const statistics = useSelector(PayPerLeadSelectors.getSubscriptionStatistics());

  const fetchSubscriptionStatistics = useFetchSubscriptionStatistics();

  useEffect(() => {
    fetchSubscriptionStatistics({});
  }, [fetchSubscriptionStatistics]);

  const monthlyLeadsLimit = statistics?.leads_total ?? 0;
  const monthlyLeadsReceived = monthlyLeadsLimit - (statistics?.unassigned_leads ?? 0);
  const monthlyDeposit = statistics?.price ?? 0;

  return {
    monthlyLeadsLimit,
    monthlyLeadsReceived,
    monthlyDeposit,
  };
};
